import { Text } from "@dutyon/ui-kit";
import { useEffect, useState } from "react";

/** Use the batch start time so polling, period changes and recovery do not reset the clock. */
export function GenerationElapsedTime({ startedAt }: { startedAt: number }) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const seconds = Math.max(0, Math.floor((now - startedAt) / 1000));
  const minutes = Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0");
  const remainder = (seconds % 60).toString().padStart(2, "0");
  return (
    <Text
      size="sm"
      c="dimmed"
      role="timer"
      aria-live="off"
      style={{ fontVariantNumeric: "tabular-nums" }}
    >
      진행 시간 {minutes}:{remainder}
    </Text>
  );
}
